import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container"]

  connect() {
    const turboFrame = this.element.closest('turbo-frame')
    if (turboFrame) {
      turboFrame.addEventListener('turbo:frame-load', this.handleFrameLoad.bind(this))
    } else {
      document.body.classList.add('overflow-hidden')
    }
  }

  disconnect() {
    const turboFrame = this.element.closest('turbo-frame')
    if (turboFrame) {
      turboFrame.removeEventListener('turbo:frame-load', this.handleFrameLoad.bind(this))
    }
    document.body.classList.remove('overflow-hidden')
  }

  handleFrameLoad() {
    document.body.classList.add('overflow-hidden')
  }

  close() {
    document.body.classList.remove('overflow-hidden')

    const turboFrame = this.element.closest('turbo-frame')
    if (turboFrame) {
      turboFrame.src = ''
      turboFrame.innerHTML = ''
    } else {
      this.containerTarget.remove()
    }
  }

  clickOutside(event) {
    if (event.target === this.containerTarget) {
      this.close()
    }
  }

    closeModal() {
    setTimeout(() => {
      this.close()
    }, 100)
  }
}
